import React from "react";
import DynamicSimpleTable from "../../../../../../../util/DynamicSimpleReactTable";
import { formatDate, formatStatus, errorMessage, formatUsername } from "../../../../../../../util/Helpers";
import cogoToast from "cogo-toast";

const ReferalBonuses = ({
    match: {
        params: {
            userId
        }
    }
}) => {
    const { PUBLIC_URL } = process.env;

    const formatInstrument = (row) => {
        return (
            <div>
                <a href={`${PUBLIC_URL}/instruments/${row?.instrumentId}`} rel="noopener noreferrer"
                    target="_blank" className="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">
                    {row.symbol}
                </a>
            </div>
        )
    }

    return <div className="card card-custom gutter-b">
        <div className="row">
            <div className="col-12">
                {/* <!--begin::List Widget 14--> */}
                <div className="card card-custom gutter-b">
                    {/* <!--begin::Header--> */}
                    <div className="card-header border-0">
                        {/* <!--begin::Title--> */}
                        <div className="card-title pt-5 w-100">
                            <h3 className="card-label">
                                <span className="d-block text-dark h3 font-weight-bolder">User Referal Bonuses</span>
                                <span className="d-block text-muted mt-2 font-size-sm">Referal rewards</span>
                            </h3>
                        </div>
                    </div>
                    {/* <!--end::Header--> */}
                    {/* <!--begin::Body--> */}
                    <div className="card-body pt-0">
                        <DynamicSimpleTable
                        key={userId}
                        searchBox={false}
                        source={{ url: `/users/referral-bonuses/${userId}` }}
                            columns={[
                                { title: "FREE STOCK", format: row => formatInstrument(row.freeStock)},
                                { title: "QUANTITY", key: "amount" },
                                { title: "STATUS", format: row => formatStatus(row.status) },
                                { title: "USER", format: row => formatUsername(row.userId, `${row.referredFirstName || row.userId} ${row.referredLastName || ""}`)},
                                { title: "EMAIL", key: "referredEmail" },
                                { title: "USER GROUP", key: "userGroup" },
                                { title: "KYC STATUS", format: row => formatStatus(row.referredKycStatus)},
                                { title: "UPDATED AT", format: row => formatDate(row.updatedAt) },
                            ]}
                            onError={(err) =>
                                cogoToast.error(errorMessage(err))
                            }
                            refreshIcon={true}
                        />
                    </div>
                    {/* <!--end::Body--> */}
                </div>
                {/* <!--end::List Widget 14--> */}
            </div>
        </div>
    </div>

}

export default ReferalBonuses;